import { type ExamFormInput } from '../../../../providers/new-exam';
import { type ExamPaperItem } from '../types';

export function mapExamFormInputToExamPaperItems(input: ExamFormInput): ExamPaperItem[] {
  return Object.entries(input).map(([questionId, item]) => ({
    id: item.examPaperItemId,
    questionId: questionId,
    answer: { value: item.answer },
  }));
}
